import { render } from "./Courselist.vue?vue&type=template&id=15ac0534&scoped=true"
import script from "./Courselist.vue?vue&type=script&lang=js"
export * from "./Courselist.vue?vue&type=script&lang=js"

import "./Courselist.vue?vue&type=style&index=0&id=15ac0534&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ac0534"]])

export default __exports__